import './TranslationProgressSection.scss';
import { Button } from '@trackman/web-shared-components';
import Subtitle from 'components/TextComps/Subtitle';
import { TranslationProgress, TranslationStatus } from 'types/admin/modulesV2';
import { TranslationStatusChip } from '../TranslationStatusChip/TranslationStatusChip';
import { useResyncTranslationV2 } from 'hooks/Admin/ModulesV2/useResyncTranslationV2';

type Props = {
  moduleId: string;
  progress?: TranslationProgress;
};

const getLanguageLabel = (code: string): string => {
  try {
    const displayNames = new Intl.DisplayNames(['en'], { type: 'language' });
    const name = displayNames.of(code);
    return name ? `${name} (${code})` : code.toUpperCase();
  } catch {
    return code.toUpperCase();
  }
};

const canResync = (status: TranslationStatus): boolean => status === 'InTranslation' || status === 'Translated';

export const TranslationProgressSection = ({ moduleId, progress }: Props) => {
  const resync = useResyncTranslationV2(moduleId);
  const languages = progress ? Object.entries(progress.statusPerLanguage) : [];

  if (languages.length === 0) {
    return null;
  }

  return (
    <div className='section-wrapper'>
      <Subtitle>
        <>Translations</>
      </Subtitle>
      <div className='translation-progress'>
        {languages.map(([language, status]) => (
          <div key={language} className='translation-progress-row'>
            <div className='language'>{getLanguageLabel(language)}</div>
            <div className='status'>
              <TranslationStatusChip status={status} />
            </div>
            <div className='actions'>
              <Button
                variant='text'
                intent='secondary'
                size='small'
                onClick={() => resync.mutate(language)}
                disabled={!canResync(status) || resync.isPending}
                isLoading={resync.isPending && resync.variables === language}
              >
                Resync
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
